import { User } from "../users/users.model";

export type Field = 'SELFIE' | 'BIO' ;

export class Requirements {

  emailSuffixes: string[] ;
  fields: Field[] ;

  public constructor() {
    this.emailSuffixes = [];
    this.fields = []
  }
}

export function hasValidEmail(user:User, requirements:Requirements) {

  if (!requirements.emailSuffixes.length)
    return true ;

  for (let suffix of requirements.emailSuffixes) {
    if (user.email.toLowerCase().endsWith(suffix.toLowerCase())) {
      return true ;
    }
  }

  return false ;
}


export function getMissingFields(user: User, requirements:Requirements): Field[] {

  let missingFields: Field[] = [] ;

  if (requirements.fields.includes('BIO')) {
    if (!user.bio || user.bio.trim().length == 0) {
      missingFields.push('BIO') ;
    }
  }

  if (requirements.fields.includes('SELFIE')) {
    if (!user.profileImage) {
      missingFields.push('SELFIE');
    }
  }

  return missingFields ;

}